// src/components/Hero.tsx
import { ArrowRight, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section 
      id="home" 
      className="min-h-screen pt-28 pb-16 flex items-center relative overflow-hidden"
      style={{
        background: "linear-gradient(to bottom, rgba(245, 240, 232, 0.95), rgba(245, 240, 232, 0.75)), url('https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container-custom grid md:grid-cols-2 gap-12 items-center">
        <div className="animate-fade-in">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-medium text-coffee-800 leading-tight tracking-tight">
            Elevate Your <br />
            <span className="text-coffee-600">Coffee</span> <br />
            Experience
          </h1>
          <p className="mt-6 text-lg md:text-xl text-coffee-700 max-w-lg">
            Carefully sourced and expertly roasted beans, delivering exceptional flavor in every cup.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/menu" className="btn-primary flex items-center gap-2">
              Explore Our Coffee <ArrowRight size={16} />
            </Link>
            <Link to="/about" className="btn-secondary flex items-center gap-2">
              Learn Our Story <ChevronRight size={16} />
            </Link>
          </div>
        </div>
        
        <div className="relative animate-slide-up md:flex justify-end hidden">
          <div className="relative w-full max-w-md aspect-square">
            <div className="absolute inset-0 rounded-full bg-coffee-200"></div>
            <img 
              src="https://images.unsplash.com/photo-1611854779393-1b2da9d400fe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80" 
              alt="Coffee cup on saucer" 
              className="rounded-full object-cover w-full h-full relative z-10 shadow-xl"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-coffee-100 to-transparent"></div>
    </section>
  );
};

export default Hero;